module.exports = __webpack_public_path__ + "img/l-hd.25b147db.jpg";